import * as React from 'react';
import { flow, get, map } from 'lodash';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { Button, Form, Grid, OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';
import * as Commonmark from 'react-commonmark';
import { MTACardHeader } from '../Components/MTACardHeader';
import { RemoveRegion } from '../../../../../../../../helpers/RemoveRegion';
import { push } from 'react-router-redux';
import { IOptionSelection } from '../../../../../../../../services/quote/models';
import { MTARegionSelector } from '../Components/MTARegionSelector';
import { MTAButtons } from '../../../MTAButtons';

interface IMTAChangeRegionFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  i18n: II18nMessages;
  formValues: any;
  selectedPolicy: any;
  dispatch: any;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions;
    push: (route: string) => void;
  };

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

class MTAChangeRegionForm extends React.Component<IMTAChangeRegionFormProps, any> {

  constructor(props) {
    super(props);
    const { dispatch, change, formValues } = props;
    dispatch(change('page', PageForm.MTA_CHANGE_REGION));
    window.scrollTo(0, 0);
    this.state = {
      allowContinue: false,
      originalSelected: get(formValues, 'metadata.region')
    }
  }

  public handleSubmit = () => {
    const { actions } = this.props;

    Promise.all([
      actions.mta.calculateMtaPremiums(),
    ]).then((data) => {
      actions.mta.addEndorsements();
      actions.mta.handleMTASubmit();
    });
  }

  private handleOnchange = (selectedValue: string) => {
    const { formValues, actions } = this.props;
    if (get(formValues, 'metadata.region') !== selectedValue) {
      actions.mta.recalculateScreening(selectedValue, 'annual');
    }
    this.setState({ allowContinue: this.state.originalSelected !== selectedValue })
  }

  private handleGoBack = () => {
    const { actions } = this.props;
    actions.mta.setCompleteMTA();
    actions.push(`/account/summary`)
  }

  render() {
    const { mta, handleSubmit, submitting, submitFailed, valid, actions, formValues } = this.props;
    const { allowContinue } = this.state;
    const product = actions.branding.getProduct();
    const isLoading = mta.isLoading;
    const hideUkRegion = get(mta, 'policyInfo.meta.hideUkRegion', false)
    const selectedRegion = get(formValues, 'metadata.region', '')

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" title="Regions">
        {!hideUkRegion && <Commonmark source={product.metadata.definitions.region_uk}/>}
        <Commonmark source={product.metadata.definitions.region_europe}/>
        <Commonmark source={product.metadata.definitions.region_worldwide_excluding}/>
        <Commonmark source={product.metadata.definitions.region_worldwide}
        />
      </Popover>
    );

    const productRegions = RemoveRegion(product.metadata.regions, hideUkRegion);

    const regionsList = map(productRegions, (name, key): IOptionSelection => {
      return {
        label: name,
        value: key,
      };
    });

    const subtext = (
      <div>Where are you travelling to?
        <span>
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            placement="bottom"
            overlay={popoverClickRootClose}
          ><FaInfoCircle className="info-btn dark_blue"/>
          </OverlayTrigger>
        </span>
      </div>
    )

    const goBackButton = (
      <Button
        bsStyle={'primary'}
        onClick={this.handleGoBack}
        className={'secondary-button'}>
        GO BACK
      </Button>
    )

    const continueButton =
      (
        <Button
          bsStyle="primary"
          type="submit"
          bsSize="small"
          className="pull-right secondary-button"
          disabled={submitting || (submitFailed && !valid || !valid || isLoading) || !allowContinue}>
          {isLoading && (
            <FaSpinner className="fa-spin"/>
          )}
          APPLY CHANGES
        </Button>
      )

    return (
      <>
        <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
          <div className="admiral-card" style={{ marginTop: '20px' }}>
            <MTACardHeader
              text={'Update your region below'}
              subtext={subtext}
              icon={'countries'}
              border={true}
            />
            <div className="body">
              <Grid fluid={true}>
                <div>
                  <MTARegionSelector
                    regionList={regionsList}
                    selectedRegion={selectedRegion}
                    handleChange={this.handleOnchange}
                  />
                </div>
              </Grid>
            </div>
          </div>
          <div className={'mt-30'}/>
          <MTAButtons button1={goBackButton} button2={continueButton}/>
        </Form>
      </>
    )
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'data.attributes',
      );
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        i18n: state.branding.i18n,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(MTAChangeRegionForm);
